<template>
    <div class="header">
      <a href="javascript:;"><img src="../../img/logo.png" alt="" class="logo"></a>
      <div class="page-name">{{name}}</div>
      <div class="rooter" @click="loginFn" v-if="onoff">
        <router-link :to="{ name: 'login'}">立即登录</router-link>
      </div>
      <div class="rooter" @click="loginFn" v-if="!onoff">
        <router-link :to="{ name: 'register'}">立即注册</router-link>
      </div>
      <span class="has-account">{{!onoff?'未有账号？':'已有账号？'}}</span>
    </div>
</template>

<script>

    export default{
      props: {
        name: {
          type: String
        },
        onoff: {
          type: Boolean
        }
      },
      data () {
        return {};
      },
      methods: {
        loginFn () {
          this.$emit('loginFn');
        }
      }
    };
</script>

<style lang="scss" scoped="" type="text/css">
  .header{height: 60px;border-bottom:#eee solid 1px;font-size:0;
    .logo{margin: 15px 0 0 66px;float: left;}
    .page-name{float:left;width: 87px;height: 30px;line-height: 30px;text-indent: 18px; font-size: 14px; background:url("../../img/icon1.png") no-repeat;margin: 16px 0 0 18px; }
    .has-account{float: right;margin:25px 22px 0 0;font-size: 14px; }
    .rooter{float: right;margin:25px 80px 0 0;font-size: 14px;color: #00a3f0;
      a{color: #00a3f0;}
    }
  }
</style>



// WEBPACK FOOTER //
// header.vue?3da67298